import React from 'react';
import axios from 'axios';
import { apiBase } from '../utils/authHeaders';

export const wasteApi = axios.create({ baseURL: `${apiBase()}/api/waste` });

// Mirrors backend waste.models.RECORDABLE_REASONS (transit_loss is report-only).
export const WASTE_REASONS = [
  { value: 'expired', label: 'Expired' },
  { value: 'spoiled', label: 'Spoiled' },
  { value: 'dropped', label: 'Dropped' },
  { value: 'overproduction', label: 'Overproduction' },
  { value: 'returned', label: 'Returned' },
  { value: 'quality_reject', label: 'Quality reject' },
  { value: 'other', label: 'Other (note required)' },
];

export const REASON_LABELS = {
  ...Object.fromEntries(WASTE_REASONS.map(r => [r.value, r.label.replace(' (note required)', '')])),
  transit_loss: 'Transit loss',
};

export const SOURCE_LABELS = {
  site_waste: 'Recorded waste',
  expiry_sweep: 'Expiry sweep',
  inventory_movement: 'Inventory movement',
  batch_reject: 'Batch rejects',
  transfer_shortfall: 'Transfer shortfalls',
};

// Display only: values stay decimal strings end to end; this formats for people.
export function money(value) {
  if (value === null || value === undefined) return 'Unknown';
  const [whole, frac = ''] = String(value).split('.');
  return `£${whole}.${(frac + '00').slice(0, 2)}${frac.length > 2 ? '…' : ''}`;
}

export function qtyByUom(map) {
  const entries = Object.entries(map || {});
  return entries.length ? entries.map(([uom, qty]) => `${qty} ${uom}`).join(', ') : '-';
}

/** Reason + note fields shared by the Waste screen and the Inventory movement form. */
export function WasteReasonFields({ reason, note, onChange }) {
  return (
    <>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Waste reason</label>
        <select aria-label="Waste reason" className="w-full border border-gray-300 rounded-md px-3 py-2"
          value={reason} onChange={e => onChange({ reason: e.target.value })}>
          {WASTE_REASONS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Waste note</label>
        <input aria-label="Waste note" type="text" maxLength={500} required={reason === 'other'}
          className="w-full border border-gray-300 rounded-md px-3 py-2"
          value={note} onChange={e => onChange({ note: e.target.value })} />
      </div>
    </>
  );
}
